import { Tabs } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import {
  COMPARISON_ID,
  METRIC_KEY,
  PLAYER_ID,
  RADAR_DATA_FORMAT,
  RADAR_TEMPLATE,
  SETTINGS_PANEL,
} from '@/consts/searchKeys';
import { useUpdateQueryString } from '@/hooks/useUpdateQueryString';
import { Tab } from '@/types/tabs';

export const PageSubNav = ({ items }: { items: { label: string; route: string }[] }) => {
  const { t } = useTranslation('navigation');
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const updateQueryString = useUpdateQueryString(searchParams);

  const hasSearchParams = searchParams.size > 0;
  // persist query params between tabs except for the ones we explicitly exclude
  const newQueryString = updateQueryString(
    [],
    [PLAYER_ID, RADAR_TEMPLATE, COMPARISON_ID, METRIC_KEY, SETTINGS_PANEL, RADAR_DATA_FORMAT],
  );
  const activeTab = items.find(item => pathname.includes(item.route))?.route || items[0].route;

  const tabs = items.map(item => ({
    label: item.label,
    value: item.route,
  }));

  return (
    <Tabs
      tabs={tabs}
      onTabChange={(_: React.MouseEvent<HTMLButtonElement, MouseEvent>, { value }: Tab<string>) => {
        const navigatePath = hasSearchParams ? `${value}?${newQueryString}` : value;
        navigate(navigatePath);
      }}
      activeTab={activeTab}
      moreButtonLabel={t('tabMore')}
    />
  );
};
